import { Autocomplete, createFilterOptions, TextField } from "@mui/material";
import { MiniCompany } from "../../types/company";
import { companySearchText } from "../../utils/companyUtils";

interface CompanySelectProps {
  companies: MiniCompany[];
  value: number | "";
  onChange: (companyId: number) => void;
  disabled?: boolean;
}

// Match on name + brand names, and cap the rendered matches so a very large company
// list stays responsive — users narrow the list by typing.
const filter = createFilterOptions<MiniCompany>({
  stringify: companySearchText,
  limit: 50,
});

export default function CompanySelect({ companies, value, onChange, disabled = false }: CompanySelectProps) {
  const selected = companies.find((c) => c.id === value) ?? null;

  return (
    <Autocomplete<MiniCompany>
      options={companies}
      value={selected}
      disabled={disabled}
      fullWidth
      size="small"
      getOptionLabel={(o) => o.name}
      getOptionKey={(o) => o.id}
      isOptionEqualToValue={(o, v) => o.id === v.id}
      filterOptions={filter}
      onChange={(_, option) => {
        if (option) onChange(option.id);
      }}
      renderInput={(params) => (
        <TextField {...params} label="Company" required size="small" />
      )}
    />
  );
}
